import React, { useState, useEffect } from 'react';
import { Popconfirm, Tag, Table, Form, Input, Button, Space, Card, Tooltip, Col, message } from 'antd';
import FilterPanel from '../../components/common/FilterPanel';
import { useTranslation } from 'react-i18next';
import { dataPermissionService } from '../../services/dataPermissionService';
import './index.css';

const DataPermissionManagement = () => {
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total, range) => `${t('common.operation')} ${range[0]}-${range[1]} / ${t('common.total')} ${total}`
    });
    const { t } = useTranslation();

    const columns = [
        {
            title: t('dataPermission.name'),
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: t('dataPermission.code'),
            dataIndex: 'code',
            key: 'code',
        },
    ];

    const fetchData = async (params = {}) => {
        setLoading(true);
        try {
            const searchParams = {
                currentPage: pagination.current,
                pageSize: pagination.pageSize,
                ...params
            };

            const response = await dataPermissionService.getDataPermissions(searchParams);

            if (response && response.success) {
                // Process the data for our component
                const data = response.data || {};
                setDataSource(data.tableData || []);
                setPagination(prev => ({
                    ...prev,
                    current: data.paging?.currentPage || pagination.current,
                    total: data.paging?.totalCount || 0
                }));
            } else {
                message.error(response?.message || '查询失败');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            message.error('查询失败，请重试');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleSearch = (values) => {
        setPagination(prev => ({ ...prev, current: 1 }));
        fetchData({ currentPage: 1, ...values });
    };

    const handleReset = () => {
        setPagination(prev => ({ ...prev, current: 1 }));
        fetchData({ currentPage: 1 });
    };

    const handleTableChange = (paginationConfig) => {
        const newPagination = {
            ...pagination,
            current: paginationConfig.current,
            pageSize: paginationConfig.pageSize
        };
        setPagination(newPagination);
        fetchData({
            currentPage: paginationConfig.current,
            pageSize: paginationConfig.pageSize
        });
    };

    return (
        <div>
            <FilterPanel
                onFilter={handleSearch}
                onReset={handleReset}
                initialValues={{}}
                title={t('dataPermission.title')}
                collapsible={true}
                defaultCollapsed={false}
                className="data-permission-search"
                loading={loading}
            >
                <Col span={8}>
                    <Form.Item name="code" label={t('dataPermission.code')}>
                        <Input placeholder={t('dataPermission.code') + t('common.search')} />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item name="nameLike" label={t('dataPermission.name')}>
                        <Input placeholder={t('dataPermission.name') + t('common.search')} />
                    </Form.Item>
                </Col>
            </FilterPanel>

            <Card className="data-permission-table">
                <Table
                    columns={columns}
                    dataSource={dataSource}
                    loading={loading}
                    pagination={pagination}
                    onChange={handleTableChange}
                    rowKey="id"
                    scroll={{ x: 1000, y: 500 }}
                />
            </Card>
        </div>
    );
};

export default DataPermissionManagement;